module.exports = {
      id: "gears-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "/app/app/assets/icons/gears.svg",
      toString: function () {
        return this.url;
      }
    }